/*
 * Copyright (c) 2008-present Sonatype, Inc.
 *
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/pro/attributions
 * Sonatype and Sonatype Nexus are trademarks of Sonatype, Inc. Apache Maven is a trademark of the Apache Foundation.
 * M2Eclipse is a trademark of the Eclipse Foundation. All other trademarks are the property of their respective owners.
 */
import React from 'react';
import {Detail, Master, MasterDetail} from '@sonatype/nexus-ui-plugin';

import ReplicationList from './ReplicationList';
import ReplicationForm from './ReplicationForm';

export default function Replication() {
  return <MasterDetail path="admin/repository/replication">
    <Master>
      <ReplicationList/>
    </Master>
    <Detail>
      <ReplicationForm/>
    </Detail>
  </MasterDetail>;
}
